import {useTheme} from '@mui/material';
import {observer} from 'mobx-react';
import FilledTextButton from '../../components/buttons/FilledTextButton';
import LineTextButton from '../../components/buttons/LineTextButton';
import * as React from 'react';
import FormTextAreaField from "../../components/fields/FormTextAreaField";
import ButtonsContainer from "../../components/medicalConsultationStepsComponents/ButtonsContainer";
import StepsMainContainer from "../../components/medicalConsultationStepsComponents/StepsMainContainer";
import {ScreenTitleBar} from "../../components/ScreenTitleBar";

function FamilyHistoryStep({patientForm, onBack, onContinue}) {
  const theme = useTheme();
  const style = styles(theme);

  const familyHistoryForm = () => {
    return (
      <section style={style.formContainer}>
        <div style={style.rowContainer}>
          <FormTextAreaField field={patientForm.getFieldByName('familyHistory')} label="Antecedentes familiares"/>
        </div>
      </section>
    )
  }

  return (
    <StepsMainContainer>

      <ScreenTitleBar title={'Antecedentes'} showBackButton={false}/>

      {familyHistoryForm()}

      <ButtonsContainer>
        <LineTextButton label="Volver" light onClick={onBack}/>
        <FilledTextButton label="Continuar" disabled={false} onClick={onContinue}/>
      </ButtonsContainer>
    </StepsMainContainer>
  );

}

export default observer(FamilyHistoryStep);

const styles = () => ({
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '10px',
    width: '70%',
  }
});